/** @jsx jsx */
// @ts-check
import { Box } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductCharacteristicsFacet from './ProductCharacteristicsFacet';
import ProductClassificationFacet from './ProductClassificationFacet';
import ProductClosureTypeFacet from './ProductClosureTypeFacet';
import ProductCountryFacet from './ProductCountryFacet';
import ProductDesignationFacet from './ProductDesignationFacet';
import {
  blendTypeToggled,
  characteristicsToggled,
  classificationToggled,
  closureTypeToggled,
  countryToggled,
  designationToggled,
  highlightToggled,
  // grapeVarietyToggled,
  mainVarietyToggled,
  priceChanged,
  priceRangeToggled,
  // nameToggled,
  productTypeToggled,
  // regionToggled,
  // subregionToggled,
  regionNameToggled,
  // denominationToggled,
  vintageToggled,
} from './productFilterReducer';
import ProductHighlightsFacet from './ProductHighlightsFacet';
// import ProductGrapeVarietiesFacet from './ProductGrapeVarietiesFacet';
import ProductPriceFacet from './ProductPriceFacet';
import ProductPriceRangeFacet from './ProductPriceRangeFacet';
import ProductRegionName from './ProductRegionNameFacet';
// import ProductNameFacet from '../Filters/Product/ProductNameFacet';
// import ProductRegionFacet from './ProductRegionFacet';
// import ProductSubregionFacet from './ProductRegionNameFacet';
import ProductTypeFacet from './ProductTypeFacet';
import ProductVarietiesFacet from './ProductVarietiesFacet';
import ProductVintageFacet from './ProductVintageFacet';
// import ProductDenominationFacet from './ProductDenominationFacet';

export default function ProductFiltersBase({
  facets,
  dispatch,
  state,
  totalCount,
  count,
  ...rest
}) {
  // console.log(facets); // Uncomment to debug the facets.
  return (
    <Box {...rest}>
      <ProductHighlightsFacet
        allValues={facets.highlights}
        selectedValues={state.highlights}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(highlightToggled(value), isActive)
        }
      />

      {facets.price && (
        <ProductPriceFacet
          values={state.price}
          onChange={(values) => dispatch(priceChanged(values))}
        />
      )}

      <ProductPriceRangeFacet
        allValues={facets.priceRanges}
        selectedValues={state.priceRanges}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(priceRangeToggled(value), isActive)
        }
      />

      <ProductTypeFacet
        allValues={facets.productType}
        selectedValues={state.productTypes}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(productTypeToggled(value), isActive)
        }
      />

      <ProductCharacteristicsFacet
        allValues={facets.characteristics}
        selectedValues={state.characteristics}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(characteristicsToggled(value), isActive)
        }
      />

      <ProductClassificationFacet
        allValues={facets.classification}
        selectedValues={state.classifications}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(classificationToggled(value), isActive)
        }
      />

      <ProductDesignationFacet
        allValues={facets.designation}
        selectedValues={state.designations}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(designationToggled(value), isActive)
        }
      />

      <ProductCountryFacet
        allValues={facets.country}
        selectedValues={state.countries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(countryToggled(value), isActive)
        }
      />
      {/* <ProductRegionFacet
        allValues={facets.region}
        selectedValues={state.regions}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(regionToggled(value), isActive)}
      />

      <ProductSubregionFacet
        allValues={facets.subregion}
        selectedValues={state.subregions}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(subregionToggled(value), isActive)
        }
      /> */}

      <ProductRegionName
        allValues={facets.regionName}
        selectedValues={state.regionNames}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(regionNameToggled(value), isActive)
        }
      />

      {/* <ProductDenominationFacet
        allValues={facets.denomination}
        selectedValues={state.denominations}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(denominationToggled(value), isActive)
        }
      /> */}

      <ProductVintageFacet
        allValues={facets.vintage}
        selectedValues={state.vintages}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(vintageToggled(value), isActive)
        }
      />
      {/* <ProductGrapeVarietiesFacet
        allValues={facets.grapeVarieties}
        selectedValues={state.grapeVarieties}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(grapeVarietyToggled(value), isActive)
        }
      /> */}
      <ProductVarietiesFacet
        allMainVarieties={facets.mainVariety}
        selectedMainVarieties={state.mainVarieties}
        allBlendTypes={facets.blendType}
        selectedBlendTypes={state.blendTypes}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(mainVarietyToggled(value), isActive)
        }
        onToggleBlendType={(value, isActive) => {
          dispatch(blendTypeToggled(value), isActive);
        }}
      />
      {/* <ProductNameFacet
          allValues={facets.name}
          selectedValues={state.names}
          totalCount={totalCount}
          count={count}
          onToggle={(value, isActive) =>
            dispatch(nameToggled(value), isActive)
          }
        /> */}
      <ProductClosureTypeFacet
        allValues={facets.closureTypes}
        selectedValues={state.closureTypes}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(closureTypeToggled(value), isActive)
        }
      />
    </Box>
  );
}

export const fragment = graphql`
  fragment bb_ProductFilters on Bottlebooks_Product {
    awards {
      award
    }
    # TODO: this should filter out everything except organic, vegan, kosher, vegetarian, biodynamic
    # characteristics
    ... on Bottlebooks_Wine {
      soilTypes {
        soilType
      }
      regionName
      denomination
    }
  }
  fragment bb_ProductFilters_RegisteredProduct on Bottlebooks_RegisteredProduct {
    highlights: customFieldValue(key: "highlights") {
      ...FieldValue
    }
    pricing {
      price
      priceRange
    }
  }
  fragment ProductFilters on Product {
    shortName
    characteristics
    vintage(removeNonVintage: true)
    productType
    wineType
    wineColor
    designation
    country(full: true)
    region
    subregion
    classification
    price
    grapeVarieties {
      varietyName
    }
    bottleVariants {
      closureType
    }
  }
`;
